import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography
} from '@mui/material'
import '../../../Style/Pulse.css'
import { useState } from 'react'
import RTEView from '../../RichTextEditor/RTEView'

const MCExample = ({}) => {
  const section = {
    pulseChoice: ['I like pizza!', 'I like hiking!']
  }
  const [userVotes, setUserVotes] = useState(
    section.pulseChoice.map(row => {
      return { label: row, value: null }
    })
  )

  const handleChange = rowIndex => {
    setUserVotes(
      userVotes.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...row,
            value: !row.value
          }
        }
        return row
      })
    )
  }

  return (
    <Stack
      spacing={{ xs: 1, md: 2 }}
      direction='column'
      justifyContent='center'
      useFlexGap
      sx={{ flexWrap: 'wrap', pb: { xs: 1, md: 2 } }}
    >
      {section.pulseChoice.map((choice, choiceIndex) => (
        <Card raised key={choiceIndex + 'choice_MCGRID'}>
          <CardActionArea
            role='checkbox'
            sx={{
              backgroundColor: userVotes[choiceIndex].value
                ? 'primary.main'
                : 'default',
              color: userVotes[choiceIndex].value
                ? 'primary.contrastText'
                : 'default'
            }}
            onClick={_e => handleChange(choiceIndex)}
          >
            <CardContent>
              <Typography variant='span' sx={{ color: 'unset' }}>
                <RTEView content={choice} />
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
      <Button variant='contained' sx={{ width: 'fit-content', ml: 'auto' }}>
        Save
      </Button>
    </Stack>
  )
}

export default MCExample
